import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const src = node.data.target.fields.file.ru.url;
      return <img src={src} alt="" />;
    },
  },
};

export const RichTextArticle = ({ body }) => {
  return <div className="content">{documentToReactComponents(body.json, options)}</div>;
};
